// removed by extract-text-webpack-plugin
module.exports = {"box":"_1R1_4NXkvfN3ngqCkp1fsf","hide":"_3czQhzEjLnnyqdU-XFAEik","noMarginOnTop":"_1Hi_zCQx29Ezx9nglDljoW","noMarginOnBottom":"_2zmLLvmhiwUTtItcnvtgi8","clickable":"_30WLyOy4e9NDrjmaUGxdNI"};


//////////////////
// WEBPACK FOOTER
// ./app/web/src/components/text/ErrorBox.css
// module id = 305
// module chunks = 0